import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export const Parallax = (image: HTMLElement, amount: number, speed: number) => {
  const section = image.closest('section') as HTMLElement
  let mm = gsap.matchMedia()

  mm.add('(min-width: 830px)', () => {
    return gsap.fromTo(
      image,
      {
        y: 0
      },
      {
        scrollTrigger: {
          trigger: section,
          scrub: 1 * speed,
          invalidateOnRefresh: true,
          // markers: true,
          start: 'top bottom',
          end: 'bottom top'
        },
        y: image.offsetHeight * amount,
        ease: 'none'
      }
    )
  })
}
